"use client";
// import * as motion from 'motion/client';
import { cn } from "@layer/utils/cn";
import { motion } from "motion/react";
import { usePathname } from "next/navigation";
import type { ComponentPropsWithoutRef } from "react";

const pageFadeIn = {
	hidden: { opacity: 0 },
	show: {
		opacity: 1,
		transition: {
			duration: 0.3,
			ease: "linear",
		},
	},
};

type PageContainerProps = ComponentPropsWithoutRef<"main"> & {
	gridPattern?: boolean;
	dotPattern?: boolean;
};

const PageContainer = ({
	children,
	className,
	gridPattern,
	dotPattern,
}: PageContainerProps) => {
	const pathname = usePathname();

	return (
		<>
			{gridPattern && (
				<div
					data-testid="page-container-grid-pattern"
					className="bg-grid absolute inset-0 -z-0 h-dvh w-full overflow-clip rounded-xl"
				/>
			)}
			{dotPattern && (
				<div
					data-testid="page-container-dot-pattern"
					className="bg-dots absolute inset-0 -z-0 h-dvh w-full bg-(length:--background-size-12)"
				/>
			)}
			<motion.main
				// TODO: Leaving here until motion is able to work with next15 & React19
				id={pathname}
				variants={pageFadeIn}
				initial="hidden"
				animate="show"
				className={cn("relative", className)}
				data-testid="page-container-main"
			>
				{children}
			</motion.main>
		</>
	);
};
export default PageContainer;
